import { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      return;
    }
    
    setSubscribeStatus('loading');
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/newsletter/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: email.trim() })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSubscribeStatus('success');
        setEmail('');
        setTimeout(() => setSubscribeStatus(''), 3000);
      } else {
        setSubscribeStatus('error');
        setTimeout(() => setSubscribeStatus(''), 3000);
        console.error('Newsletter subscription error:', data.error);
      }
    } catch (error) {
      setSubscribeStatus('error');
      setTimeout(() => setSubscribeStatus(''), 3000);
      console.error('Newsletter subscription error:', error);
    }
  };

  return (
    <footer className="bg-white border-t border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand Section */}
          <div className="col-span-1">
            <Link to="/" className="flex items-center">
              <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent font-fraunces">
                Moodshelf
              </span>
            </Link>
            <p className="mt-4 text-sm text-gray-600 font-space">
              Discover your next favorite book! We'd love to hear from you, shoot us an email.
            </p>
            <div className="mt-6 flex space-x-4">
              
              
              <a href="mailto:hello@moodshelf.io" className="text-gray-400 hover:text-gray-500 transition-colors">
                <span className="sr-only">Email</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div className="col-span-1 md:col-span-2 md:col-start-3 md:justify-self-end">
            <h3 className="text-sm font-semibold text-gray-900 font-space">Stay Updated</h3>
            <p className="mt-4 text-sm text-gray-600 font-space">
              Subscribe to our newsletter for curated book recommendations and reading insights.
            </p>
            <form onSubmit={handleSubscribe} className="mt-4">
              <div className="flex flex-col space-y-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="px-4 py-2 text-sm bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent font-space"
                  required
                />
                <button
                  type="submit"
                  disabled={subscribeStatus === 'loading'}
                  className={`px-4 py-2 text-sm text-white bg-gradient-to-r from-purple-600 to-blue-600 rounded-lg transition-opacity font-space ${
                    subscribeStatus === 'loading' 
                      ? 'opacity-50 cursor-not-allowed' 
                      : 'hover:opacity-90'
                  }`}
                >
                  {subscribeStatus === 'loading' ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              {subscribeStatus === 'loading' && (
                <p className="mt-2 text-xs text-blue-600 bg-blue-50 px-3 py-2 rounded-lg font-space">
                  Subscribing...
                </p>
              )}
              {subscribeStatus === 'success' && (
                <p className="mt-2 text-center text-xs text-green-600 bg-green-50 px-3 py-2 rounded-lg font-space">
                  Thanks for subscribing! 🎉
                </p>
              )}
              {subscribeStatus === 'error' && (
                <p className="mt-2 text-xs text-red-700 bg-red-100 px-3 py-2 rounded-lg font-space">
                  Failed to subscribe. Please try again.
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-100">
          <p className="text-center text-xs text-gray-500 font-space">
            © {new Date().getFullYear()} Moodshelf. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 